import { calculateEngagementFromDate } from "../../utils/members.util";
import { EngagementTag } from "./Tag";
import Tooltip from "./Tooltip";

export function engagementTooltip(lastMessageAt: Date | null | undefined): string {
    if (!lastMessageAt) {
        return "Haven't messaged with us";
    }

    const engagement = calculateEngagementFromDate(new Date(), lastMessageAt);
    switch (engagement.level) {
        case "poor":
            return "Messaged us over 2 weeks ago";
        case "average":
            return "Messaged us 1-2 weeks ago";
        case "good":
            return "Messaged us within a week";
        default:
            return "";
    }
}
type EngagementIndicatorProp = {
    lastMessageAt: Date | null | undefined;
    className?: string;
};

const EngagementIndicator = function EngagementIndicator(
    props: EngagementIndicatorProp,
) {
    const { lastMessageAt, className } = props;
    const engagement = calculateEngagementFromDate(new Date(), lastMessageAt);

    return (
        <Tooltip label={engagementTooltip(lastMessageAt)} placement="top-left">
            <EngagementTag className={className} engagement={engagement} />
        </Tooltip>
    );
};

export default EngagementIndicator;
